<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="btn-group float-end">
        @if (this.user?.roles.includes('CONTROLLER') && this.teams?.length>0) {
          <button type="button"
            class="btn btn-lg btn-primary" (click)="newProcess()">
            <lucide-icon name="plus" size="16"></lucide-icon>
            <div style="float:right; margin-left: 5px;">
              {{ 'CONTROL-MODULE.CREATE_PROCESS' | translate }}
            </div>
          </button>
        }
      </div>

    </div>

  </div>

  <div class="row">
    <div class="col">
      <app-step-tabber [steps]="steps" [type]="stepperType"></app-step-tabber>
    </div>
  </div>

  <br />

</div>
